import { currency } from '@ecg-marktplaats/aurora-js-formatters';
import { TListingPrice } from 'types/Listings';

/**
 * Formats price name or monetary value
 * Ported from @ecg-marktplaats/aurora-templates/src/helpers/formatPrice.js
 */
export default function formatPrice(price: TListingPrice, t: TI18nContext['t']): string {
  const { price: priceCents, priceType } = price;
  const hasMonetaryValue = ['FIXED', 'FREE_BID', 'MIN_BID'].includes(priceType);

  return hasMonetaryValue ? currency(priceCents, true) : t(`priceTypes:prices.${priceType}`);
}
